export default "__VITE_ASSET__qA3VsTLS__"